<template>
  <div class="addInvensList">
    <div class="inventorys">
      <div class="mainTit">盘点单</div>
      <el-form :model="form" :rules="rules">
        <el-row>
          <el-col :span='20'>
            <div style="line-height:40px">服务类商品</div>
          </el-col>
          <el-col :span='2'>
            <el-button class="darkBtn" @click="outportExcel">导出</el-button>
          </el-col>
        </el-row>
        <el-table :data="tableData.detailList" ref="multipleTable" :cell-class-name="tableRowClassName" class="subsidiary" style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
          <el-table-column align="center">
            <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
            <el-table-column align="center" prop="productNo" label="商品编号">
              <template slot-scope="scope">{{scope.row.productNo | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="productName" label="商品名称">
              <template slot-scope="scope">{{scope.row.productName | filterRow}}</template>
            </el-table-column>
            <el-table-column align="center" prop="expiryDate" label="最近有效期">
              <template slot-scope="scope">{{scope.row.expiryDate | filterRow}}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" :label="'可售库存' + (tableData.scope == 1 ? '(次)':(tableData.scope == 2 ? '(套)':'(件)'))">
            <el-table-column align="center" prop="availableCount" label="账面数量" >
                <template slot-scope="scope">
                    <div :class="scope.row.availableCount != scope.row.realAvailableCount?'redLight':'noLight'">
                        {{scope.row.availableCount}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="realAvailableCount" label="实际数量">
                <template slot-scope="scope">
                    <div :class="scope.row.availableCount != scope.row.realAvailableCount?'redLight':'noLight'">
                        {{scope.row.realAvailableCount}}
                    </div>
                </template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="寄存库存(套）" v-if="tableData.scope == 'all' || tableData.scope == '2' ">
            <el-table-column align="center" prop="depositCount" label="账面数量">
                <template slot-scope="scope">
                    <div :class="scope.row.depositCount != scope.row.realDepositCount?'redLight':'noLight'">
                        {{scope.row.depositCount}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="realDepositCount" label="实际数量">
                <template slot-scope="scope">
                    <div :class="scope.row.depositCount != scope.row.realDepositCount?'redLight':'noLight'">
                        {{scope.row.realDepositCount}}
                    </div>
                </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="12">
            <div class="toptit">盘点结果</div>
            <div class="results">
              <span>正常：</span>
              {{tableData.normalNum}} 个
              <span>异常：</span>
              {{tableData.abnormalNum}} 个
            </div>
            <div class="toptit">盘点说明</div>
            <div class="explain">{{tableData.remarks}}</div>
          </el-col>
          <el-col :span="12" class="peopleList">
            <el-form-item label="盘点人：">{{tableData.operatorName}}</el-form-item>
            <el-form-item label="检查人：">{{tableData.examinerName}}</el-form-item>
            <el-form-item label="记录人：">{{tableData.noteTakerName}}</el-form-item>
            <p class="redFont">*注：建议由不同人员去盘点</p>
          </el-col>
        </el-row>
        <el-row class="btnOptions">
          <el-button class="darkBtn" @click="onClose">关闭</el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script type="text/javascript">
import {stockTakingInfo, exportStockTakingList } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      tableData: [],
      form: {
        checkPeople: "",
        examPeople: "",
        notePeople: ""
      },
      rules: {},
      fullscreenLoading: false,
      dialogTableVisible: false //修改手工费弹窗
    };
  },
  created() {
    this.search();
  },
  methods: {
    async search(val) {
      this.fullscreenLoading = true;
      let res = await stockTakingInfo({
        id: this.$route.params.id,
      });
      this.fullscreenLoading = false;
      this.tableData = res.data;
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) { //把每一行的索引放进row
      row.index = rowIndex;
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    outportExcel(){
      let postData = {
        id:this.$route.params.id,
        serviceType:this.tableData.scope
      }
      this.$http.post(exportStockTakingList, postData, {
        headers:{
          userId:this.$store.state.userInfo.redisKey
        },
        responseType: "blob"
      })
      .then(res => {
        if(res.data.type == "application/json"){
          this.$message({
            message: '无盘点单信息！',
            type: 'error'
          });
          return
        }
        const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
        const fileName = '盘点单明细.xls';
        if('msSaveOrOpenBlob' in navigator){
            navigator.msSaveOrOpenBlob(blob, '盘点单明细.xls');
            return;
        }
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a');
          elink.download = fileName;
          elink.style.display = 'none';
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        }else{
          navigator.msSaveBlob(blob, fileName);
        }
      })
    },
    onClose() {
      // 关闭
      this.$router.push("/businessManagementCenter/inventory");
    },
  },
};
</script>
<style lang="less" scoped>
.inventorys {
  padding: 25px 0;
  .redFont {
    color: #f83b56; //红色字
  }
  .mainTit {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
  }
  .toptit {
    margin-top: 25px;
  }
  .subsidiary {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .results {
    margin-top: 25px;
    span {
      color: #666;
      font-size: 13px;
      margin-left: 90px;
    }
  }
  .explain{
      padding: 0 0 0 90px;
      line-height: 30px;
      max-width: 370px;
  }
  .peopleList{
      margin: 20px 0 0;
      .el-form-item{
          margin-bottom: 40px;
      }
  }
  .btnOptions {
    text-align: center;
    margin: 45px;
    .el-button {
      width: 110px;
      height: 45px;
    }
  }
}
</style>
<style lang="less">
.addInvensList {
  .el-dialog__title {
    font-weight: bold;
  }
}
.subsidiary {
  .el-table__header {
    thead.is-group {
      tr {
        &:first-child {
          th {
            background: #fff !important;
          }
        }
      }
    }
  }
  .el-table__row {
    td {
      padding:0;
      .cell{
          padding:0;
      }
      .el-form-item__content {
        line-height: 28px;
      }
    }
  }
  .el-input__inner {
    width: 82px;
    height: 28px;
    line-height: 28px;
    text-align: center;
  }
  .highLight {
    background: #eff1f5;
  }
  .redLight {
    background: #fedee3;
    color: #f83b56;
    padding: 8px 0;
    .el-input__inner {
      color: #f83b56;
    }
  }
  .noLight{
      padding: 8px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessManagementCenter/inventorView.vue